import styled from "styled-components";
import { colors } from "../../../../../assets";

export const TableContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: auto;

  table {
    height: 100%;
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    text-align: left;

    th {
      border: none;
      border-bottom: 2px solid ${colors["PR-001-100"]};
      background-color: ${colors["msg-info"]};
      padding: 10px;
      width: fit-content;
      white-space: nowrap;

      &.header {
        text-align: right;
      }
    }

    td {
      border: none;
      padding: 10px;
    }

    tfoot td {
      border: none;
      border-top: 2px solid ${colors["PR-001-100"]};
      background-color: ${colors["msg-info"]};
      font-weight: bold;
      width: fit-content;
      white-space: nowrap;
    }

    tbody tr:hover {
      background-color: ${colors["table-row-hover"]};
      .fix-column {
        background-color: ${colors["table-row-hover"]};
      }
    }

    .fix-column {
      position: sticky;
      left: 0;
      z-index: 1;
      box-shadow: 3px 0 5px -2px rgba(136, 136, 136, 0.3);
    }

    tbody td.fix-column {
      background-color: #ffffff;
      z-index: 2;
    }

    .number {
      text-align: right;
      padding-right: 30px;
    }

    .month {
      > td {
        padding-left: 30px;
      }
    }
    .year {
      font-weight: bold;
      td {
        border: none;
        border-bottom: 2px solid ${colors["PR-001-100"]};
      }
    }

    .strong {
      font-weight: bold;
    }

    .product {
      > td {
        padding-left: 60px;
      }
    }

    input[type="checkbox"] {
      position: relative;
      width: 20px;
      height: 20px;
      appearance: none;
      margin: 0 5px 0 0;
      cursor: pointer;
      color: ${colors["PR-001-100"]};

      &::before {
        content: "";
        position: absolute;
        transform: translate(20%, 80%) rotate(225deg);
        width: 10px;
        height: 10px;
        border-right: 3px solid;
        border-bottom: 3px solid;
        transition: transform 0.2s ease;
      }

      &:checked::before {
        transform: translate(20%, 50%) rotate(45deg);
      }
    }

    .row {
      &-expanded {
      }
      &-contracted {
        display: none;
      }
    }
  }

  &.small {
    max-height: 800px;
    table {
      // width: max-content;
    }
  }

  &.sticky-header {
    thead {
      position: sticky;
      z-index: 1;
      top: 0;
    }
  }
`;
